<template>
  <footer class="step-footer">
    <div>
      <PflegeButton
        v-if="
          wizco.activeStep.content.buttonLabel ||
          wizco.activeStep.content.nextStepButtonLabel ||
          wizco.activeStep.content.nextStepButtonIcon
        "
        :class="{ isDisabled: !wizco.isActiveStepReady }"
        :label="
          wizco.activeStep.content.nextStepButtonLabel || wizco.activeStep.content.buttonLabel
        "
        :icon="wizco.activeStep.content.nextStepButtonIcon"
        :loading="wizco.isStepLoading || wizco.isLoading"
        :disabled="wizco.isLoading"
        v-bind="$attrs"
      />
      <PflegeButton
        v-if="
          wizco.activeStep.content.prevStepButtonLabel ||
          wizco.activeStep.content.prevStepButtonIcon
        "
        :variant="wizco.activeStep.content.prevStepButtonVariant ?? 'text'"
        :label="wizco.activeStep.content.prevStepButtonLabel"
        :icon="wizco.activeStep.content.prevStepButtonIcon"
        :disabled="wizco.isStepLoading || wizco.isLoading"
        @click="wizco.stepBack"
      />
    </div>

    <PflegeAlert v-if="props.errorMessage" :variant="props.errorVariant">
      {{ props.errorMessage }}
      <slot name="alert"></slot>
    </PflegeAlert>
  </footer>
</template>

<script setup>
import { useWizcoStore } from '../../stores/wizco'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  errorMessage: {
    type: String,
    required: false,
    default: null
  },
  errorVariant: {
    type: String,
    required: false,
    default: 'warning',
    validator: (val) => ['info', 'success', 'warning', 'danger'].includes(val)
  }
})

const wizco = useWizcoStore()
</script>

<style scoped>
.step-footer {
  padding-block-end: 1rem;
}
.step-footer > div {
  padding-block: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
}
.step-footer > div :deep(button) {
  width: 100%;
}
</style>
